import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchProductService(params) {
  return await request({
    url: ENDPOINT.HOME_PRODUCT_SERIVICE_TRYING,
    method: "get",
    params,
  });
}

export async function fetchProductServiceById(id) {
  return await request({
    url: `${ENDPOINT.HOME_PRODUCT_SERIVICE_TRYING}/${id}/edit`,
    method: "get",
  });
}

export async function createProductService(data) {
  return await request({
    url: ENDPOINT.HOME_PRODUCT_SERIVICE_TRYING,
    method: "post",
    data,
  });
}

export async function updateProductService(id, data) {
  return await request({
    url: `${ENDPOINT.HOME_PRODUCT_SERIVICE_TRYING}/${id}`,
    method: "post",
    data,
  });
}

export async function deleteProductService(id, data) {
  return await request({
    url: `${ENDPOINT.HOME_PRODUCT_SERIVICE_TRYING}/${id}`,
    method: "post",
    data
  });
}